<template>
  <v-expansion-panel>
    <v-expansion-panel-title v-slot="{ expanded }">
      <v-row no-gutters>
        <v-col cols="4" class="text-primary "> Bon de Livraison </v-col>
        <v-col cols="8" class="text-medium-emphasis">
          <v-fade-transition leave-absolute>
            <span v-if="expanded" key="edit"> Editer le bon puis sauvegarder </span>
            <div v-else key="summary">
              <div v-if="bonLivraison.account">
                {{ bonLivraison.account.name }}
              </div>
              <div v-if="bonLivraison.laverie">/ {{ bonLivraison.laverie.name }}</div>
            </div>
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-autocomplete v-model="bonLivraison.account" :items="accounts" item-title="name" return-object
            label="Siège"></v-autocomplete>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le compte siège
        </v-col>
      </v-row>
      <v-row v-if="bonLivraison.account" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-autocomplete v-model="bonLivraison.laverie" :items="laveries" item-title="name" return-object
            label="Laverie"></v-autocomplete>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la laverie
        </v-col>
      </v-row>
      <v-row v-if="bonLivraison.laverie && bonLivraison.laverie.address" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="1" class="pr-1">
          <v-text-field name="numero" hint="Le numéro dans la rue" v-model="bonLivraison.laverie.address.numero"
             label="Numero">
          </v-text-field>
        </v-col>
        <v-col cols="5" class="pl-1">
          <v-text-field name="rue" hint="Le nom de la rue" v-model="bonLivraison.laverie.address.rue"
             label="Rue">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Changez l'adresse si nécessaire
        </v-col>
      </v-row>
      <v-row v-if="bonLivraison.laverie && bonLivraison.laverie.address" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="1" class="pr-1">
          <v-text-field name="codepostale" hint="Le code postale de la ville"
            v-model="bonLivraison.laverie.address.codepostale"  label="Code Postale">
          </v-text-field>
        </v-col>
        <v-col cols="5" class="pl-1">
          <v-text-field name="ville" hint="Le nom de la ville" v-model="bonLivraison.laverie.address.ville"
             label="Ville">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonLivraison.laverie" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field v-model="bonLivraison.deliveryDate" type="date">
            <template #label>
              Date de Livraison<span class="text-red"><strong> *</strong></span>
            </template>
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la date de livraison
        </v-col>
      </v-row>
      <v-row v-if="bonLivraison.deliveryDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="2" class="pr-1">
          <v-text-field name="etage" v-model="bonLivraison.accessibility.etage" 
            label="Etage">
          </v-text-field>
        </v-col>
        <v-col cols="2" class="px-1">
          <v-text-field name="ascenseur" v-model="bonLivraison.accessibility.ascenseur" 
            label="Ascenseur">
          </v-text-field>
        </v-col>
        <v-col cols="2" class="pl-1">
          <v-text-field name="escalier" v-model="bonLivraison.accessibility.escalier" 
            label="Escalier">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Détaillez l'accessibilité
        </v-col>
      </v-row>
      <v-row v-if="bonLivraison.deliveryDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="2" class="pr-1">
          <v-text-field name="codePorte" v-model="bonLivraison.laverie.codeAcces" 
            label="Code Porte">
          </v-text-field>
        </v-col>
        <v-col cols="2" class="px-1">
          <v-text-field name="parkingPrive" v-model="bonLivraison.accessibility.parking" 
            label="Parking Privé">
          </v-text-field>
        </v-col>
        <v-col cols="2" class="pl-1">
          <v-text-field name="cle" v-model="bonLivraison.accessibility.key"  label="Clé">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonLivraison.deliveryDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-autocomplete v-model="bonLivraison.deliveredBy" :items="users" item-title="fullName" return-object
            label="Livré par"></v-autocomplete>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le livreur
        </v-col>
      </v-row>
      <template v-if="bonLivraison.deliveredBy">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-text-field name="gestionnaire" hint="Nom et prénom du gestionnaire"
              v-model="bonLivraison.laverie.gestionnaire"  label="Gestionnaire">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Changez le gestionnaire si nécessaire
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="3" class="pr-1">
            <v-text-field name="mobile" v-model="bonLivraison.laverie.telephonePrincipal" 
              label="Mobile">
            </v-text-field>
          </v-col>
          <v-col cols="3" class="pl-1">
            <v-text-field name="telephone" v-model="bonLivraison.laverie.telephoneAutre" 
              label="Téléphone">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3"> </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-text-field name="contactSecondPrenom" hint="Nom et prénom du contact secondaire"
              v-model="bonLivraison.contactSecond.name"  label="Autre contact">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Renseignez un contact secondaire
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-text-field name="contactSecondFonction" hint="Fonction technique du contact secondaire"
              v-model="bonLivraison.contactSecond.fonction"  label="Fonction">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3"> </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="3" class="pr-1">
            <v-text-field name="contactSecondMobile" hint="Mobile du contact secondaire"
              v-model="bonLivraison.contactSecond.mobile"  label="Mobile">
            </v-text-field>
          </v-col>
          <v-col cols="3" class="pl-1">
            <v-text-field name="contactSecondTel" hint="Téléphone du contact secondaire"
              v-model="bonLivraison.contactSecond.telephone"  label="Téléphone">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3"> </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-text-field name="bonLivraisonObservations" hint="Observations" v-model="bonLivraison.observations"
               label="Observations">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Notez les observations en cas de non installation
          </v-col>
        </v-row>
      </template>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onCancel" text color="red"> Cancel </v-btn>
        <generate-doc-btn :filePath="bonLivraisonTemplatePath" :fileName="bonLivraisonFileName"
          :dataSet="bonLivraisonGen">Save</generate-doc-btn>
      </v-card-actions>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import GenerateDocBtn from "@/components/GenerateDocBtn.vue";
import type { BonLivraison } from "@/types";
import { flattenBonLivraison } from "@/types";
import type { Accessibility } from "@/types";
import type { User } from "@/types";
import type { Account } from "@/types";
import type { Laverie } from "@/types";
import { getLaveriesByAccountId } from "@/utils/laverie-api";
import { watch } from "vue";

interface Props {
  accounts: Account[];
  users: User[];
}

const props = defineProps<Props>();

const bonLivraison = ref<BonLivraison>({
  accessibility: {} as Accessibility,
  contactSecond: {} as User,
} as BonLivraison);

const laveries = ref<Laverie[]>([]);

const bonLivraisonGen = computed(() =>
  flattenBonLivraison(bonLivraison.value)
);

const bonLivraisonTemplatePath = "templates/BonLivraisonTemplate.docx";

const bonLivraisonFileName = computed(() => {
  if (bonLivraison.value.laverie) {
    return "BonDeLivraison_".concat(bonLivraison.value.laverie.name);
  }
  return "BonDeLivraison";
});

watch(
  () => bonLivraison.value.account,
  async (selectedAccount) => {
    if (!selectedAccount) return;

    // Reset selected laverie
    bonLivraison.value.laverie = null;
    laveries.value = [];

    await fetchLaveries(selectedAccount.id);
  }
);

const fetchLaveries = async (accountId: string) => {
  try {
    laveries.value = await getLaveriesByAccountId(accountId);
  } catch (error) {
    console.error("Error fetching laveries:", error);
    laveries.value = [];
  }
};

const onCancel = () => {
  // TODO clear form
  bonLivraison.value = {
    accessibility: {} as Accessibility,
    contactSecond: {} as User,
  } as BonLivraison;
  laveries.value = [];
};
</script>
